<template>
  <button
    :disabled="loading"
    type="button"
    @click="() => selectDivision(division)"
    v-bind:class="[
              { active: selectedDivision === division.id || (selectedDivisions ?? []).includes(division.id) || division.selected },
              'btn btn-outline-info'
            ]"
  >
    <p class="division_runner">{{
        division?.user?.short_name || division?.user?.name || getUsersByDivision(division.id)
      }}</p>
    <p class="d_info"><strong>{{ division.title }}</strong>
      <template v-if="orderStatuses">
        <span class="badge badge-info">{{ orderStatuses.waiting ?? 0 }}</span>
        <span class="badge badge-success">{{ orderStatuses.appointed ?? 0 }}</span>
        <span class="badge badge-warning">{{ orderStatuses.overdue ?? 0 }}</span>
      </template>
    </p>
    <hr/>
    <p class="d_info_city">
                <span v-for="(city, index) in division.cities"
                >{{
                    index > 0 ? ', ' : ''
                  }}{{ $AllCities[city.object_id]?.name }}</span
                >
    </p>
  </button>
</template>
<script>
export default {
  props: ['division', 'orderStatuses', 'overDueOrders', 'selectedDivision', 'selectedDivisions', 'divUsers', 'loading', 'showReport'],
  computed: {
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  methods: {
    selectDivision(division) {
      if (this.showReport) {
        this.showReport(null, division.id)
      } else {
        this.division.selected = !this.division.selected;
      }
    },
    getUsersByDivision(divId) {
      let text = ''
      if (this.divUsers?.[divId]) {
        this.divUsers[divId].forEach((u, i) => {
          if (i > 0 && i !== this.divUsers[divId].length) {
            text += ', '
          }
          text += u.short_name ?? u.name
        })
      } else {
        text = 'не определен'
      }
      return text
    },
  }
}
</script>

<style scoped>
p {
  font-size: 12px;
  margin-bottom: 3px;
}

hr {
  margin: 3px 0;
}
</style>
